import { z } from "zod";

/**
 * Schema for editing company details.
 *
 * Note: Most company fields are synced from Salesforce and are read-only.
 * Only fieldServiceSoftwareId can be edited through the Hub UI.
 */
export const editCompanySchema = z.object({
  fieldServiceSoftwareId: z.number().nullable().optional(),
});

// Schema for syncing company from Salesforce
export const syncCompanyFromSalesforceSchema = z.object({
  intacctId: z.string().min(1, "Intacct ID is required"),
});

// Type inference
export type EditCompanyFormData = z.infer<typeof editCompanySchema>;
export type SyncCompanyFromSalesforceFormData = z.infer<
  typeof syncCompanyFromSalesforceSchema
>;
